<template lang="pug">
  section(class="jumbo")
    .jumbo-wrapper
      .jumbo-figure
        h1 {{titulo}}
          small {{bajada}}
</template>

<script>
export default {
  name: 'Jumbo',
  props: {
    titulo: {
      type: String,
      default: 'Título'
    },
    bajada: {
      type: String,
      default: 'Bajada'
    }
  }
}
</script>

<style scoped lang="scss">
  .jumbo {
    height: 90vh;
    overflow: hidden;
    position: relative;
    background-color: black;
    @media all and (max-width: 800px){
      min-height: 60vh;
    }
  }
  .jumbo-wrapper{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .jumbo-figure{
    max-width: 80%;
    text-align: center;
  }
  h1{
    color: white;
    font-weight: 900;
    @include fluid-type(360px, 1440px, 30px, 70px);
    small {
      display: block;
      font-size: 2rem;
      @media all and (max-width: 800px){
        font-size: 1.2rem;
      }
    }
  }
</style>